/**
 * Gets the index of the category sort.
 * @param {string} category The category to get the index of.
 */
export const getCategorySortIndex = function( category ) {
  switch ( category?.toUpperCase() ) {
    case "CONSULTANCY": {
      return 1;
    }
    case "SUBSCRIPTION": {
      return 2;
    }
    case "CONFERENCE":
    case "TRAINING/CONFERENCE":
    case "TRAINING": {
      return 3;
    }
    default: {
      return 10;
    }
  }
};
